
/* Tin & Tinder PDP behaviour */
(function(){
  function gallery(root){
    var stage = root.querySelector('[data-tt-stage]');
    var img = stage && stage.querySelector('img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tt-thumb]'));
    if(!img) return;
    var i = 0;
    function show(n){
      if(!thumbs.length) return;
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      img.src = t.getAttribute('data-src');
      img.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function(b){ b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
      stage.classList.remove('is-zoom');
    }
    thumbs.forEach(function(t, n){ t.addEventListener('click', function(){ show(n); }); });
    var next = root.querySelector('[data-tt-next]');
    if(next) next.addEventListener('click', function(){ show(i + 1); });
    var zoom = root.querySelector('[data-tt-zoom]');
    if(zoom) zoom.addEventListener('click', function(){ stage.classList.toggle('is-zoom'); });
    if(stage) stage.addEventListener('click', function(){ if(stage.classList.contains('is-zoom')) stage.classList.remove('is-zoom'); });
    if(thumbs.length) show(0);
  }

  function rail(root){
    var track = root.querySelector('[data-tt-rail]');
    if(!track) return;
    var bar = root.querySelector('[data-tt-progress] span');
    function sync(){
      if(!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? track.scrollLeft / max : 0;
      var w = Math.max(12, (track.clientWidth / track.scrollWidth) * 100);
      bar.style.width = w + '%';
      bar.style.left = (pct * (100 - w)) + '%';
    }
    track.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    var prev = root.querySelector('[data-tt-prev]');
    var next = root.querySelector('[data-tt-fwd]');
    function step(dir){ track.scrollBy({left: dir * Math.round(track.clientWidth * 0.8), behavior:'smooth'}); }
    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });
    sync();
  }

  function sticky(){
    var bar = document.querySelector('[data-tt-sticky]');
    var anchor = document.querySelector('[data-tt-buyrow]');
    if(!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var past = e.boundingClientRect.top < 0 && !e.isIntersecting;
        bar.classList.toggle('is-on', past);
      });
    }, {threshold: 0}).observe(anchor);
  }

  function init(){
    document.querySelectorAll('[data-tt-gallery]').forEach(gallery);
    document.querySelectorAll('[data-tt-railroot]').forEach(rail);
    sticky();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
